import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://imperio-ia.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-192" data-mp="31lkejb9t5l4b">
      <div className="max-w-3xl mx-auto" data-id="element-193" data-mp="2wlg0drwdh2h9">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-emerald-500/30 text-center relative overflow-hidden" data-id="element-194" data-mp="2wmr1fjyfnw4o">
          <div className="absolute -right-10 -top-10 text-emerald-500/10" data-id="element-195" data-mp="3p9k78gqojllj">
            <ShieldCheck className="w-64 h-64" data-id="element-196" data-mp="3pbo6umhjpyg0" />
          </div>
          <div className="relative z-10" data-id="element-197" data-mp="3khahp1th8njs">
            <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-6" data-id="element-198" data-mp="3fjigtiautr3g" />
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-199" data-mp="3fhef970fh46c">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-200" data-mp="c2s3eicy0brq">
              Comprás, abrís los tomos y los aplicás. El riesgo es nuestro.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-201" data-mp="2hkmgj3ev0bxi">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-202" data-mp="2lkew402o7icd" />
              <strong className="text-white" data-id="element-203" data-mp="2ln0xtj2vr3mo">devolución del 100%</strong>
              <br data-id="element-204" data-mp="27t0armlaj525" />
              sin formularios, sin drama.
            </p>
            <p className="text-sm text-emerald-400/80 font-medium" data-id="element-205" data-mp="2crtggsuc5rrr">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca usé herramientas de IA?',
    a: 'Sí. El Tomo 1 está diseñado exactamente para eso. Explica el sistema desde cero sin asumir ningún conocimiento previo. Cualquier persona con una computadora y conexión a internet puede implementarlo desde el primer día.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al completar el pago recibís un email con acceso inmediato a todos los tomos y bonos en formato PDF. En menos de 5 minutos tenés todo descargado y listo para usar.'
  }, {
    q: '¿Qué lo diferencia de buscar tutoriales en YouTube?',
    a: 'Los tutoriales te dan información suelta sin orden ni sistema. El Megapack te da un método completo con herramientas listas para aplicar, conectadas entre sí y orientadas a generar resultados desde el primer día. No estás estudiando, estás ejecutando.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si abrís los tomos y sentís que no es lo que necesitabas, te devolvemos el 100% del dinero sin hacer preguntas. Sin formularios. Sin esperas.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-206" data-mp="3qszjcezsyvbb">
      <div className="max-w-3xl mx-auto" data-id="element-207" data-mp="s27fphgpzl40">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 flex items-center justify-center gap-3" data-id="element-208" data-mp="s392gj73lw1k">
          <span className="text-brand-400" data-id="element-209" data-mp="na6848uhyikb">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-210" data-mp="uo6rv8vli3uo">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-xl bg-slate-900 overflow-hidden" data-id="element-211" data-mp="zkx9w1qyn9iq" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-212" data-mp="14mwcvaisg4f5">
                <span className="font-bold text-white pr-8" data-id="element-213" data-mp="1djngc7zo6ljr">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-400 shrink-0" data-id="element-214" data-mp="1nbb2puhddced" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-215" data-mp="1ndniq23khcos" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-216" data-mp="1xaa4ct3pw7rv">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-217" data-mp="2yyx6xxarwq7q">
      <div className="max-w-4xl mx-auto" data-id="element-218" data-mp="2yxuhltt3mvtx">
        <div className="text-center mb-8" data-id="element-219" data-mp="2u1du91tq4lhw">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-220" data-mp="2u0lwbkcnmbog">
            <Scale className="w-9 h-9 text-amber-400" data-id="element-221" data-mp="37ud5grmh3tjn" /> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-222" data-mp="2g0t9w185uhma">
          <table className="w-full text-left border-collapse bg-slate-900 rounded-xl overflow-hidden" data-id="element-223" data-mp="2g1mkjda8pr9p">
            <thead data-id="element-224" data-mp="2b3krq0n0idl1">
              <tr className="border-b border-slate-800 bg-slate-800/50" data-id="element-225" data-mp="2b42xpozh8665">
                <th className="p-4 text-slate-300 font-medium" data-id="element-226" data-mp="2p3cbyj44gq7h">Sin Megapack</th>
                <th className="p-4 text-red-400 font-bold" data-id="element-227" data-mp="2k1mxethoxuen">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-228" data-mp="4a8sssb72l4p">
              <tr data-id="element-229" data-mp="3vi3fyvojkr5q">
                <td className="p-4 text-slate-400" data-id="element-230" data-mp="3vimnrjkh9z61">
                  Cursos sueltos que nunca terminás × 12 meses
                </td>
                <td className="p-4 text-white font-medium" data-id="element-231" data-mp="7s69g75j5ihc">
                  +USD 600.00 al año
                </td>
              </tr>
              <tr data-id="element-232" data-mp="3u0xryr6t7kax">
                <td className="p-4 text-slate-400" data-id="element-233" data-mp="3u1haoa4aacq0">
                  20 minutos de confusión nocturna × 365 días
                </td>
                <td className="p-4 text-white font-medium" data-id="element-234" data-mp="2uwmcy5m5iwo">
                  121 horas de estrés por año
                </td>
              </tr>
              <tr data-id="element-235" data-mp="visk866x5gv1">
                <td className="p-4 text-slate-400" data-id="element-236" data-mp="vjbr8rv16kua">
                  Herramientas que pagás y no sabés usar
                </td>
                <td className="p-4 text-white font-medium" data-id="element-237" data-mp="gtml0i82zqn5">
                  USD 10.00–20.00 por mes tirados
                </td>
              </tr>
              <tr data-id="element-238" data-mp="19j3953oo4ldk">
                <td className="p-4 text-slate-400" data-id="element-239" data-mp="19ijpnijddoxf">
                  Domingo estudiando sin sistema ni resultados
                </td>
                <td className="p-4 text-white font-medium" data-id="element-240" data-mp="1eaur4ptrdis3">
                  El mismo agotamiento el próximo lunes
                </td>
              </tr>
              <tr data-id="element-241" data-mp="1j5xf0u7rfuv7">
                <td className="p-4 text-slate-400" data-id="element-242" data-mp="1j7qqcmtbj39j">
                  Clientes que no llegan por falta de método
                </td>
                <td className="p-4 text-white font-medium" data-id="element-243" data-mp="1e9fek6jgqioo">
                  5 oportunidades perdidas por semana
                </td>
              </tr>
              <tr data-id="element-244" data-mp="156xwm4aucc7h">
                <td className="p-4 text-slate-400" data-id="element-245" data-mp="1588wht160ztb">
                  Información acumulada que no sabés cómo usar
                </td>
                <td className="p-4 text-white font-medium" data-id="element-246" data-mp="10e4n734fgfp2">
                  Decisión bloqueada cada noche
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-247" data-mp="qfxawxl32lte">
          <h3 className="text-2xl font-bold text-brand-400 mb-4" data-id="element-248" data-mp="mevbogr629rf">
            El próximo lunes empieza igual o empieza distinto. Lo decidís hoy.
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-500 pl-6 py-2 text-left" data-id="element-249" data-mp="2t4ykd6jnrhmu">
            "La diferencia entre los profesionales que dominan la IA y los que
            no, no es el talento ni la experiencia. Es el sistema."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-slate-900 border-brand-500/50 text-center" data-id="element-250" data-mp="372wx67ibz608">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-251" data-mp="2aeh441g0ieid">
            <Clock className="w-5 h-5" data-id="element-252" data-mp="2edg89jtx678r" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-253" data-mp="2jcsrzvphuy74">
            <div className="p-6 border border-slate-700 rounded-xl bg-slate-800/50" data-id="element-254" data-mp="2o6na4upgb543">
              <h4 className="font-bold text-white mb-2" data-id="element-255" data-mp="1qpf56qfifj0q">
                🤖 MEGAPACK RECURSOS DIGITALES
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-256" data-mp="1vmygpiktphoz">
                6 Tomos + 5 Bonos · Todo el año resuelto
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-257" data-mp="k2w1b5bnm7j5">
                <span className="text-slate-500 line-through text-sm" data-id="element-258" data-mp="k4yv80fxgkt5">
                  USD 49.99
                </span>
                <span className="text-3xl font-black text-white" data-id="element-259" data-mp="u0af0x670i7r">
                  USD 19.99
                </span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-260" data-mp="17za05uuhyez6">
                → QUIERO MI MEGAPACK
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-261" data-mp="1crtfaw8u1i63">
            <span className="flex items-center" data-id="element-262" data-mp="1qruiiickl1oq">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-263" data-mp="1lrzs0fwpie47" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-264" data-mp="25drttufk0jev">
              <Zap className="w-4 h-4 mr-1 text-amber-400" data-id="element-265" data-mp="25f2w1ptcpj3v" /> Acceso en 5
              minutos
            </span>
            <span className="flex items-center" data-id="element-266" data-mp="2accm97okdysr">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-267" data-mp="1wdd3ggnqge4i" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-268" data-mp="20dx0lk8b3hqn">
              <CreditCard className="w-4 h-4 mr-1 text-blue-400" data-id="element-269" data-mp="20gja3perc7bi" /> Mercado Pago
              | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-900" data-id="element-270" data-mp="1cpm6czx48gbc">
      <div className="max-w-4xl mx-auto text-center" data-id="element-271" data-mp="1ho6y0ayaxro6">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-272" data-mp="1hoyrng8c9fbt">
          <span className="text-2xl" data-id="element-273" data-mp="13nw6r6t2yb2h">🤖</span>
          <span className="text-brand-400 font-bold tracking-widest uppercase" data-id="element-274" data-mp="13p7lg1o2d38d">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-275" data-mp="34a00atfotl4h">
          El sistema de productividad digital N°1 para freelancers y
          emprendedores argentinos que quieren dominar la Inteligencia
          Artificial sin improvisar todas las semanas.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-276" data-mp="2vb677d1kfcvo">
          Porque resolver cómo usar la IA no debería costarte todos los domingos
          del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-277" data-mp="3nz2006o0kkn6">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-400 transition-colors" data-id="element-278" data-mp="3ryswmr081uzm">
            📧 supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-279" data-mp="3j5fx367njv4k">
            🌐 www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-280" data-mp="fhxg3t45g3fj">
          <p data-id="element-281" data-mp="fji9vgin3icc">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-282" data-mp="ovxw6kt3262z">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-900" data-id="element-283" data-mp="kv5jtiowzl2h">
          <p className="text-brand-500/50 font-medium italic" data-id="element-284" data-mp="yn28tdvadeun">
            🤖 "El próximo lunes puede ser diferente."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-285" data-mp="tohiq79r0bjx">
            "Un arsenal de recursos digitales no es solo información. Es
            tranquilidad profesional."
          </p>
        </div>
      </div>
    </footer>;
}